export default {
  labelColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Color",
      description: null
    },
    value: null
  },
  outlineColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Outline color",
      description: "Color of the outline"
    },
    value: null
  },
  secLabelColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Color",
      description: null
    },
    value: null
  },
  background: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Background",
      description: null
    },
    value: null
  },
  increaseFill: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Increase",
      description: null
    },
    value: null
  },
  decreaseFill: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Decrease",
      description: null
    },
    value: null
  },
  totalFill: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Total",
      description: null
    },
    value: null
  },
  fillColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Fill color",
      description: null
    },
    value: null
  },
  otherFill: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Other",
      description: null
    },
    value: null
  },
  titleColor: {
    properties: {
      component: 'Color',
      type: "fill",
      visible: 'showAxisTitle',
      displayName: "Title color",
      description: null
    },
    value: null
  },
  foreground: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: {
        visualHeader: "Color",
        advanced: "First-level elements",
        default: "Background"
      },
      description: null
    },
    value: null
  },
  good: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Positive",
      description: null
    },
    value: null
  },
  neutral: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Neutral",
      description: null
    },
    value: null
  },
  bad: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Background",
      description: null
    },
    value: null
  },
  maximum: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Maximum",
      description: null
    },
    value: null
  },
  center: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Center",
      description: null
    },
    value: null
  },
  minimum: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Minimum",
      description: null
    },
    value: null
  },
  foregroundColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Color",
      description: null
    },
    value: null
  },
  primaryColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Primary color",
      description: null
    },
    value: null
  },
  primaryFontColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Primary text color",
      description: null
    },
    value: null
  },
  secondaryColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Secondary color",
      description: null
    },
    value: null
  },
  secondaryFontColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Secondary text color",
      description: null
    },
    value: null
  },
  canvasColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Background color",
      description: null
    },
    value: null
  },

  gridVerticalColor: {
    properties: {
      component: 'Color',
      type: "fill",
      visible: 'gridVertical',
      displayName: "Vert grid color",
      description: "Color for the vertical gridlines"
    },
    value: null
  },
  gridHorizontalColor: {
    properties: {
      component: 'Color',
      type: "fill",
      visible: 'gridHorizontal',
      displayName: "Horiz grid color",
      description: "Color for the horizontal gridlines"
    },
    value: null
  },
  secTitleColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Title color",
      description: null
    },
    value: null
  },
  defaultColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Default color",
      description: null
    },
    value: null
  },
  referenceLineColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Reference line color",
      description: null
    },
    value: null
  },
  fill: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Fill",
      description: null
    },
    value: null
  },
  questionFontColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Question font color",
      description: null
    },
    value: null
  },
  acceptedColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Accepted underline color",
      description: null
    },
    value: null
  },
  errorColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Error underline color",
      description: null
    },
    value: null
  },
  lastDateFontColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Last date color",
      description: null
    },
    value: null
  },
  warningColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Warning underline color",
      description: null
    },
    value: null
  },
  hoverColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Hover underline color",
      description: null
    },
    value: null
  },
  restatementFontColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Restatement font color",
      description: null
    },
    value: null
  },
  xxx: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "xxx",
      description: null
    },
    value: null
  },
  headerFontColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Header font color",
      description: null
    },
    value: null
  },
  cardBackground: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Card background color",
      description: null
    },
    value: null
  },
  geoSearchFill: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Card background color",
      description: null
    },
    value: null
  },
  cardFontColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Card font color",
      description: null
    },
    value: null
  },
  defaultCategoryColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Default color",
      description: null
    },
    value: null
  },
  gridlineColor: {
    properties: {
      component: 'Color',
      type: "fill",
      visible: 'gridlineShow',
      displayName: "Gridline color",
      description: null
    },
    value: null
  },
  lineColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Color",
      description: "Set trend line color"
    },
    value: null
  },
  backgroundColor: {
    properties: {
      component: 'Color',
      type: "fill",
      visible: 'enableBackground',
      displayName: "Background Color",
      description: null
    },
    value: null
  },
  markerColor: {
    properties: {
      component: 'Color',
      type: "fill",
      visible: 'showMarker',
      displayName: "Marker color",
      description: null
    },
    value: null
  },
  fontColorPrimary: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Font color",
      description: "Font color of the odd rows"
    },
    value: null
  },
  barColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Bar color",
      description: null
    },
    value: null
  },
  backColorPrimary: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Background color",
      description: "Background color of the odd rows"
    },
    value: null
  },
  backColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Background color",
      description: "Background color of the cells"
    },
    value: null
  },
  cardBackground: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Background",
      description: null
    },
    value: null
  },
  fontColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Font color",
      description: "Font color of the cells"
    },
    value: null
  },
  legendColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Color",
      description: null
    },
    value: null
  },
  accentColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Accent Color",
      description: null
    },
    value: null
  },
  expandCollapseButtonsColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Collapse Buttons Color",
      description: null
    },
    value: null
  },
  connectorDefaultColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Default Color",
      description: null
    },
    value: null
  },
  goalFontColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Font Color",
      description: null
    },
    value: null
  },
  distanceFontColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Distance Font Color",
      description: null
    },
    value: null
  },
  levelHeaderBackgroundColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Header Background Color",
      description: null
    },
    value: "#000000"
  },
  titleFontColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Title Font Color",
      description: null
    },
    value: "#252423"
  },
  levelSubtitleFontColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Subtitle Font Color",
      description: null
    },
    value: "#FFFFFF"
  },
  inputBoxColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Input Box Color",
      description: null
    },
    value: "#FFFFFF"
  },

  levelTitleFontColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Title Font Color",
      description: null
    },
    value: "#ABCDEF"
  },
  checkboxAndApplyColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Checkbox And Apply Color",
      description: null
    },
    value: "#a78c17"
  },
  dataLabelFontColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Label Font Color",
      description: null
    },
    value: null
  },
  fontColorSecondary: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Alternate font color",
      description: "Font color of the even rows"
    },
    value: null
  },
  backColorSecondary: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Alternate background color",
      description: "Background color of the even rows"
    },
    value: null
  },
  borderColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Color",
      description: null
    },
    value: null
  },
  categoryLabelFontColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Color",
      description: null
    },
    value: "#0100AA"
  },
  goodColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Good Color",
      description: null
    },
    value: null
  },
  foregroundNeutralSecondary: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Second-level elements",
      description: null
    },
    value: null
  },
  backgroundLight: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Third-level elements",
      description: null
    },
    value: null
  },
  foregroundNeutralTertiary: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Fourth-level elements",
      description: null
    },
    value: null
  },
  backgroundNeutral: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Secondary background elements",
      description: null
    },
    value: null
  },
  actionFontColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Action Font Color",
      description: null
    },
    value: "#AFB5B6"
  },
  valueFontColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Value Font Color",
      description: null
    },
    value: "#AFB5B6"
  },
  dataBarBackgroundColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Bar Background Color",
      description: null
    },
    value: "#AFB5B6"
  },
  negativeBarColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Bar negative Color",
      description: null
    },
    value: "#FF0F12"
  },
  positiveBarColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Bar positive Color",
      description: null
    },
    value: "#00FF2E"
  },
  badColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Bad Color",
      description: null
    },
    value: null
  },
  neutralColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Neutral Color",
      description: null
    },
    value: null
  },
  color: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Color",
      visible: 'showAxisTitle',
      description: {
        categoryAxis: "Select color for data labels"
      }
    },
    value: null
  },
  color0: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Color",
      visible: 'showAxisTitle',
      description: null
    },
    value: null
  },
  color100: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Color",
      visible: 'showAxisTitle',
      description: null
    },
    value: null
  },
  'color-1': {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Color",
      description: null
    },
    value: "#002a5b"
  },
  'color-2': {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Color",
      description: null
    },
    value: "#002a5b"
  },
  'color-3': {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Color",
      description: null
    },
    value: "#002a5b"
  },
  'color-4': {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Color",
      description: null
    },
    value: "#002a5b"
  },
  'color-5': {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Color",
      description: null
    },
    value: "#002a5b"
  },
  'color-6': {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Color",
      description: null
    },
    value: "#002a5b"
  },
  'color-7': {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Color",
      description: null
    },
    value: "#002a5b"
  },
  'color-8': {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Color",
      description: null
    },
    value: "#002a5b"
  },
  'color-9': {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Color",
      description: null
    },
    value: "#002a5b"
  },
  'color-10': {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Color",
      description: null
    },
    value: "#002a5b"
  },
  foregroundColor: {
    properties: {
      component: 'Color',
      type: "fill",
      displayName: "Color",
      description: {
        categoryAxis: "Select color for data labels"
      }
    },
    value: null
  },
}